import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import BranchTransferPendingFilters from "./components/BranchTransferPendingFilters";
import BranchTransferPendingTable from "./components/BranchTransferPendingTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportBranchTransferPendingCsv } from "./components/exportBranchTransferPendingCsv";

const { Title } = Typography;

const BranchTransferPendingList = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list } = useSelector(
    (state) => state.branchTransferPending
  );

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Branch Transaction Pending List",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportBranchTransferPendingCsv({
      list,
      title:    "Branch Transaction Pending List",
      filename: "branch_transfer_pending",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} className="reportBigTitle" >Branch Transaction Pending List</Title>}
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />
        <BranchTransferPendingFilters />
        <Card className="shadow-md rounded-xl">
          <BranchTransferPendingTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Branch Transaction Pending List"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <BranchTransferPendingTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default BranchTransferPendingList;
